export default function MySQL_SYSDATE() {
  return (
    <div>
      <h2>MySQL_SYSDATE</h2>    </div>
  );
}